import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { InlineTimePicker } from "material-ui-pickers";
import { compose } from "recompose";
import Time from "@material-ui/icons/AccessTime";
import Clear from "@material-ui/icons/CancelOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";
import appConstants from "../../../../appConstants";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import { isValid as isDateTimeValid, parse, format } from "date-fns";

const styles = (theme) => ({
  container: {
    backgroundColor: theme.ModalBGColor,
    minHeight: "24px",
    boxSizing: "border-box",
    marginTop: 6,
    display: "flex",
    flexDirection: "row",
    maxWidth: "220px",
    "&>div": {
      margin: "0px 5px",
    },
    '& $inputRoot input$inputStyle[type="text"]': {
      fontSize: theme.textFontSize,
      color: theme.TextColor,
      border: "none",
      height: 24,
      paddingBottom: 0,
      "&:focus": {
        border: "none",
        paddingBottom: 0,
      },
      "&::placeholder": {
        color: "currentColor",
      },
    },
    // '& span[class*="MuiPickersClockNumber-clockNumber"]':{
    //     color: theme.TextColor
    // },
    // '& p[class*="MuiFormHelperText-root"][class*="MuiFormHelperText-error"]':{
    //     backgroundColor: theme.ComponentHeader,
    //     marginTop:0,
    //     paddingTop:8,
    //     color: theme.ErrorMessageColor,
    //     fontSize:theme.textFontSize
    // },
    "& $inputRoot": {
      marginTop: 0,
    },
  },
  dateTimeContainer: {
    maxWidth: "175px",
    flexDirection: "column",
  },
  paperStyle: {
    backgroundColor: theme.ModalBGColor,
    color: theme.TextColor,
  },
  labelProps: {
    fontSize: theme.textFontSize,
    color: theme.iconColor,
    marginTop: -16,
  },
  labelShrink: {
    marginTop: -8,
  },
  inputStyle: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    padding: 0,
  },
  inputRoot: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    borderBottom: `1px solid ${theme.iconColor}`,
    maxHeight: 24,
    "&::before, &::after": {
      border: "none !important",
    },
    "&$inputFocus": {
      borderBottom: `1px solid ${theme.HeaderSelectedText}`,
    },
  },
  inputFocus: {},
  iconColor: {
    color: theme.iconColor,
  },
  inputAdornment: {
    cursor: "pointer",
    marginBottom: 0,
  },
  errorMessage: {
    display: "none",
  },
  errorMessageVisible: {
    display: "block",
    marginBottom: 0,
    color: theme.ErrorMessageColor,
    fontSize: theme.textFontSize,
  },
  editorContainer: {
    backgroundColor: theme.ComponentHeader,
    paddingTop: 2,
    border: `1px solid ${theme.iconColor}`,
    marginTop: -4,
    alignItems: "center",
    display: "flex",
  },
  closedDayInputStyle: {
    color: theme.SelectedStopBorderColor,
  },
  closedDayEditorContainer:{
    backgroundColor: theme.ComponentHeader,
    paddingTop:2,
    marginTop:-4
  },
});

class TimeRange extends React.Component {
  constructor(props) {
    super(props);
    this.timeConfig = appConstants.DATETYPES.TIME;
    this.INVALID_TIME = "Invalid_Time";
    this.minTimeErrorElement = null;
    this.endTimeInputRef = React.createRef();
    this.state = {
      startTime: null,
      endTime: null,
    };
  }

  componentDidMount() {
    this.updateTime();
  }

  updateTime = () => {
    const [startTime, endTime] =
      this.props.value && this.props.value.split("-").length === 2
        ? this.props.value
            .split("-")
            .map((time) =>
              parse(time.trim(), this.timeConfig.format, new Date())
            )
        : [null, null];
    this.setState({
      startTime,
      endTime,
    });
    this.props.onChange(this.props.value);
  };

  startDateChanged = (startTime) => {
    this.setState(
      {
        startTime,
      },
      this.validateTimeWindow
    );
  };

  endDateChanged = (endTime) => {
    this.setState(
      {
        endTime,
      },
      this.validateTimeWindow
    );
  };

  openStartPicker = (event) => {
    this.startPicker.open(event);
  };

  openEndPicker = (event) => {
    this.endPicker.open(event);
  };

  onStartInputChange = (event) => {
    const updatedDateTime = parse(
      event.target.value,
      this.timeConfig.format,
      new Date()
    );
    if (isDateTimeValid(updatedDateTime)) {
      this.startDateChanged(updatedDateTime);
    } else {
      this.showMinTimeError();
      this.updateParentValue(this.INVALID_TIME);
    }
  };

  onEndInputChange = (event) => {
    const updatedDateTime = parse(
      event.target.value,
      this.timeConfig.format,
      new Date()
    );
    if (isDateTimeValid(updatedDateTime)) {
      this.endDateChanged(updatedDateTime);
    } else {
      this.showMinTimeError();
      this.updateParentValue(this.INVALID_TIME);
    }
  };

  validateTimeWindow = () => {
    let timeRange = "";
    if (!this.state.startTime && !this.state.endTime) {
      timeRange = null;
    } else if (
      isDateTimeValid(this.state.startTime) &&
      isDateTimeValid(this.state.endTime)
    ) {
      if (this.state.startTime > this.state.endTime) {
        timeRange = this.INVALID_TIME;
        this.showMinTimeError(
          `End Time should be greater than  ${format(
            this.state.startTime,
            this.timeConfig.format
          )}`
        );
      } else {
        timeRange = `${format(
          this.state.startTime,
          this.timeConfig.format
        )} - ${format(this.state.endTime, this.timeConfig.format)}`;
        this.showMinTimeError();
      }
    } else {
      timeRange = this.INVALID_TIME;
    }
    // Update the parent value
    this.updateParentValue(timeRange);
  };

  showMinTimeError = (errorMessage) => {
    if (!this.minTimeErrorElement) {
      this.minTimeErrorElement = document.createElement("p");
      this.minTimeErrorElement.className = `MuiFormHelperText-root MuiFormHelperText-error ${this.props.classes.errorMessage}`;
      if (
        this.endTimeInputRef &&
        this.endTimeInputRef.current &&
        this.endTimeInputRef.current.parentElement &&
        this.endTimeInputRef.current.parentElement.parentElement
      ) {
        this.endTimeInputRef.current.parentElement.parentElement.appendChild(
          this.minTimeErrorElement
        );
      }
    }
    if (errorMessage) {
      this.minTimeErrorElement.classList.add(
        this.props.classes.errorMessageVisible
      );
      this.minTimeErrorElement.textContent = errorMessage;
    } else {
      this.minTimeErrorElement.classList.remove(
        this.props.classes.errorMessageVisible
      );
    }
  };

  updateParentValue = (value) => {
    this.props.onChange?.(value);
  };

  render() {
    const { classes, node } = this.props;
    const {
      isClosedDay = "",
      startLabel = null,
      endLabel = null,
      autoFocus = true,
      isInputBorderRequired = true,
    } = this.props?.componentSpecificProps ?? {};
    return (
      <div
        className={
          isInputBorderRequired
            ? classes.editorContainer
            : classes.closedDayEditorContainer
        }
        style={{ minHeight: node?.rowHeight }}
      >
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div
            className={`theme-${this.props.theme.themeName} ${classes.container}`}
          >
            <InlineTimePicker
              keyboard
              clearable
              disableOpenOnEnter
              label={startLabel ?? "Start Time"}
              format={this.timeConfig.format}
              placeholder={this.timeConfig.placeholder}
              ampm={false}
              value={this.state.startTime}
              onChange={this.startDateChanged}
              onClear={this.startDateChanged}
              mask={this.timeConfig.inputMask}
              ref={(element) => (this.startPicker = element)}
              PopoverProps={{
                disablePortal: true,
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelProps,
                  shrink: classes.labelShrink,
                },
              }}
              InputProps={{
                autoFocus: autoFocus,
                endAdornment: (
                  <InputAdornment
                    position="end"
                    classes={{ root: classes.inputAdornment }}
                  >
                    {
                      <Clear
                        classes={{ root: classes.iconColor }}
                        onClick={() => this.startDateChanged(null)}
                      />
                    }
                    {
                      <Time
                        classes={{ root: classes.iconColor }}
                        onClick={this.openStartPicker}
                      />
                    }
                  </InputAdornment>
                ),
                classes: {
                  root: classes.inputRoot,
                  input: isClosedDay
                    ? classes.closedDayInputStyle
                    : classes.inputStyle,
                  focused: classes.inputFocus,
                },
                inputRef: this.props.startTimeInputRef,
              }}
              // classes={{
              //     popoverPaper: classes.paperStyle,
              // }}
              onInputChange={this.onStartInputChange}
              invalidDateMessage={`Invalid Time`}
            />
            <InlineTimePicker
              keyboard
              clearable
              disableOpenOnEnter
              label={endLabel ?? "End Time"}
              format={this.timeConfig.format}
              placeholder={this.timeConfig.placeholder}
              ampm={false}
              value={this.state.endTime}
              onChange={this.endDateChanged}
              onClear={this.endDateChanged}
              mask={this.timeConfig.inputMask}
              ref={(element) => (this.endPicker = element)}
              PopoverProps={{
                disablePortal: true,
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelProps,
                  shrink: classes.labelShrink,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    classes={{ root: classes.inputAdornment }}
                  >
                    {
                      <Clear
                        classes={{ root: classes.iconColor }}
                        onClick={() => this.endDateChanged(null)}
                      />
                    }
                    {
                      <Time
                        classes={{ root: classes.iconColor }}
                        onClick={this.openEndPicker}
                      />
                    }
                  </InputAdornment>
                ),
                classes: {
                  root: classes.inputRoot,
                  input: isClosedDay
                    ? classes.closedDayInputStyle
                    : classes.inputStyle,
                  focused: classes.inputFocus,
                },
                inputRef: this.endTimeInputRef,
              }}
              // classes={{
              //     popoverPaper: classes.paperStyle
              // }}
              onInputChange={this.onEndInputChange}
              invalidDateMessage={`Invalid Time`}
            />
          </div>
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

export default compose(withTheme(styles), withStyles(styles))(TimeRange);
